export const DEPLOYMENT_ENV_TYPE_PROD = 'PROD';
export const DEPLOYMENT_ENV_TYPE_UAT = 'UAT';
export const DEPLOYMENT_ENV_TYPE_DEV = 'DEV';

// DEVELOPMENT environment properties
export const ACTIVE_DEPLOYED_ENV = DEPLOYMENT_ENV_TYPE_DEV;

const hostName = window.location.hostname;

const productionURL = 'http://realvalue.kprosai.com:80/kpros-realvalue-lms-api';
const productionDomainURL = 'http://realvalue.kprosai.com:80';
const developmentURL = 'http://realvalue.kprosai.com:80/kpros-realvalue-lms-api';
const developmentDomainURL = 'http://realvalue.kprosai.com:80';

export function dynamicLessEmiUrl() {
  let lessEmiUrl;
  let lessEmiDomainUrl;

  if (hostName === 'realvalue.kprosai.com') {
    lessEmiUrl = productionURL;
    lessEmiDomainUrl = productionDomainURL;
  } else if (hostName === 'localhost') {
    lessEmiUrl = developmentURL;
    lessEmiDomainUrl = developmentDomainURL;
  } else {
    lessEmiUrl = productionURL;
    lessEmiDomainUrl = productionDomainURL;
  }

  return {
    lessEmiUrl: lessEmiUrl,
    lessEmiDomainUrl: lessEmiDomainUrl
  };
}

export const globalAdminUrl = dynamicLessEmiUrl().lessEmiUrl;
// export const globalAdminUrl = developmentURL;

// export const domainUrl = dynamicLessEmiUrl().lessEmiDomainUrl;
export const domainUrl = `${window.location.origin}/`;
// export const domainUrl = developmentDomainURL;

// export const globalAdminUrlTest = 'https://1ce7-122-160-199-112.ngrok-free.app/lms-api';

// for DEVELOPMENT
// export const globalAdminUrl = 'http://164.52.218.84:8080/lms-api';

// for LOCALHOST
// export const globalAdminUrl = 'http://localhost:8080/lms-api';

// ##Below are the "Partner to Offline" web app. redirection links:
// for PRODUCTION
export const PARTNER_TO_OFFLINE_URL = 'http://164.52.208.46/v2';

// export const domainUrl = 'http://klass-uat.kalolytic.com/';
// export const domainUrl = 'http://localhost:3000/';

// for DEVELOPMENT
// export const PARTNER_TO_OFFLINE_URL = 'http://offline-prod.kalolytic.com/v2';

// for LOCALHOST
// export const PARTNER_TO_OFFLINE_URL = 'http://localhost:3001/v2';

// for PRODUCTION - RECOMMENDATION module - PYTHON API BASE URL
export const RECOMMENDATION_PYTHON_PROD_API_BASE_URL = 'http://216.48.180.65:6060';

// for UAT - RECOMMENDATION module - PYTHON API BASE URL
export const RECOMMENDATION_PYTHON_UAT_API_BASE_URL = 'http://216.48.180.65:6060';

// for DEVELOPMENT - RECOMMENDATION module - PYTHON API BASE URL
export const RECOMMENDATION_PYTHON_DEV_API_BASE_URL = 'http://216.48.180.65:6060';

// for PRODUCTION - RECOMMENDATION module - RECOMMENDATION RESULT API endpoint
export const RECOMMENDATION_RESULTS_PROD_API_ENDPOINT = 'recommendationResults';

// for UAT - RECOMMENDATION module - RECOMMENDATION RESULT API endpoint
export const RECOMMENDATION_RESULTS_UAT_API_ENDPOINT = 'recommendationResultsDev';

// for DEVELOPMENT - RECOMMENDATION module - RECOMMENDATION RESULT API endpoint
export const RECOMMENDATION_RESULTS_DEV_API_ENDPOINT = 'recommendationResultsDev';
